import { useHasPermission } from '../../hooks/useHasPermission';
import { Box, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import Iconify from '../Iconify';
import React from 'react';
import '../../css/sites/sitesPageHeader.css';

const SitesPageHeader = ({ setOpenAddSite }) => {

    const { t } = useTranslation();
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
    const hasSitesCreatePermission = useHasPermission('site_create');

    return (
        <Box className='site_headre_main_container'>
            <Box className='site_headre_title_box'>
                <Typography className='site_headre_page_title'>Sites</Typography>
            </Box>
            {(isDesktop && hasSitesCreatePermission) &&
                <Box className='site_headre_action_box' onClick={() => setOpenAddSite(true)}>
                    <Iconify className='site_headre_add_icon' icon={"ic:baseline-plus"} />
                    <Typography className='site_headre_action_title'>{t("addSiteButtonTitle")}</Typography>
                </Box>
            }
            {(!isDesktop && hasSitesCreatePermission) &&
                <Box className='site_headre_action_box'>
                    <Iconify className='site_headre_add_icon' icon={"ic:baseline-plus"} onClick={() => setOpenAddSite(true)} />
                </Box>
            }
        </Box>
    );
};

export default React.memo(SitesPageHeader);